export function plural(n: number, noun: string) {
  return n === 1 ? `${n} ${noun}` : `${n} ${noun}s`
}

function safeParseInt(value?: string): number | undefined {
  if (!value) return
  const n = parseInt(value, 10)
  if (!isNaN(n)) return n
}

export const chromeVersion = safeParseInt(navigator.userAgent.match(/Chrome\/(\d+)/)?.[1])
export const hasSFLetterSpacingBug = chromeVersion && chromeVersion >= 137

export const ICON_SIZE = 16
